import {initialSickDaysState, ISickDaysState} from '@app/core/store/state/sick-days.state';
import {EErrorActions, ErrorActions} from '@app/core/store/actions/error.actions';
import {ESickDaysActions, SickDaysActions} from '@app/core/store/actions/sick-days.actions';

export const sickDaysReducers = (
	state = initialSickDaysState,
	action: SickDaysActions | ErrorActions,
): ISickDaysState => {
	switch (action.type) {
		case EErrorActions.LoadError: {
			return {
				...state,
				isLoading: false,
			};
		}
		case ESickDaysActions.GetSickDays: {
			return {
				...state,
				isLoading: true,
			};
		}
		case ESickDaysActions.GetSickDaysSuccess: {
			return {
				...state,
				isLoading: false,
				sickDays: action.sickDays,
				pagination: action.pagination,
			};
		}
		case ESickDaysActions.PostSickDay: {
			return {
				...state,
				isLoading: true,
			};
		}
		case ESickDaysActions.PostSickDaySuccess: {
			return {
				...state,
				isLoading: false,
				sickDays: [action.sickDay, ...state.sickDays],
			};
		}
		case ESickDaysActions.ApproveSickDay: {
			return {
				...state,
				isLoading: true,
			};
		}
		case ESickDaysActions.ApproveSickDaySuccess: {
			return {
				...state,
				isLoading: false,
				sickDays: state.sickDays.filter(s => s.id !== action.sickDay.id),
			};
		}
		case ESickDaysActions.DeleteSickDay: {
			return {
				...state,
				isLoading: true,
			};
		}
		case ESickDaysActions.DeleteSickDaySuccess: {
			return {
				...state,
				isLoading: false,
				sickDays: state.sickDays.filter(s => s.id !== action.sickDay.id),
			};
		}
		case ESickDaysActions.RespondSickDaySuccess: {
			return {
				...state,
				sickDays: state.sickDays.filter(s => s.id !== action.response.sick_message.id),
			};
		}

		case ESickDaysActions.GetSickDayAnswers: {
			return {
				...state,
				isLoadingAnswers: true,
			};
		}
		case ESickDaysActions.GetSickDayAnswersSuccess: {
			return {
				...state,
				isLoadingAnswers: false,
				answers: action.answers,
			};
		}

		default:
			return state;
	}
};
